<template>
    <v-dialog max-width="auto" v-model="openPaiementLogs">
         <v-card >
           <v-card-title>
             <div class="col-12 mb-0 pb-0">
               <span class="ml-2">Logs des paiement de la transaction <strong class="text-lowercase">{{transaction_data ? transaction_data._name : ''}}</strong></span>
               <div style="position: absolute; right:5px; top:5px">
                 <v-icon @click="closeLogsTransaction" style="cursor:pointer" >mdi-close</v-icon>
               </div>
             </div>
           </v-card-title>
           <v-card-text>
             <div class="col-12 mt-0 pt-0" v-if="transaction_data">
                <v-row v-if="transaction_data._programmation">
                   <v-col  cols="12" lg="3" md="4" class="mt-0 pt-0">
                     <v-card style="padding: 15px;">
                       <div class="row" style="background: #fff">
                         <div class="col-md-12 pt-2 pb-0">
                           <v-icon large>mdi-swap-horizontal</v-icon>
                         </div>
                         <div class="col-md-12 ">
                           <div>Désignation :</div>
                           <div style="font-weight: bold">
                             {{transaction_data ? transaction_data._name : ''}}
                           </div>
                         </div>
                       </div>

                     </v-card>
                   </v-col>
                   <v-col cols="12" lg="3" md="4" class="mt-0 pt-0">
                     <v-card style="padding: 15px;">
                       <div class="row"  style="background: #fff">
                         <div class="col-md-12 pt-2 pb-0">
                           <v-icon large>mdi-recycle</v-icon>
                         </div>
                         <div class="col-md-12 ">
                           <div>Type de programmation:</div>
                           <div style="font-weight: bold" class="text-uppercase">
                             {{ transaction_data._programmation._type_programmation ? transaction_data._programmation._type_programmation : '' }}
                             <span class="badge badge-warning" v-if="transaction_data._programmation._type_programmation==='periodique'">{{transaction_data._programmation._periodicite}}</span>
                           </div>
                         </div>
                       </div>
                     </v-card>
                   </v-col>
                   <v-col  cols="12" lg="3" md="4" class="mt-0 pt-0">
                     <v-card style="padding: 15px;">
                       <div class="row"  style="background: #fff">
                         <div class="col-md-12 pt-2 pb-0">
                           <v-icon large>mdi-message-badge-outline</v-icon>
                         </div>
                         <div class="col-md-12 ">
                           <div>Canal de Transmission:</div>
                           <div style="font-weight: bold">
                             {{  transaction_data._programmation._canal_transmission  }}  </div>
                         </div>
                       </div>

                     </v-card>
                   </v-col>
                   <v-col  cols="12" lg="3" md="4" class="mt-0 pt-0">
                     <v-card style="padding: 15px">
                       <div class="row"  style="background: #fff">
                         <div class="col-md-12 pt-2 pb-0">
                           <v-icon large>mdi-cash-multiple</v-icon>
                         </div>
                         <div class="col-md-12 ">
                           <div>Montant Total à payer:</div>
                           <div style="font-weight: bold">
                             {{ transaction_data._amount }} XOF
                             </div>
                         </div>
                       </div>
                     </v-card>
                   </v-col>
                     <v-col  cols="12" lg="3" md="4" class="mt-0 pt-0">
                     <v-card style="padding: 15px">
                       <div class="row"  style="background: #fff">
                         <div class="col-md-12 pt-2 pb-0">
                           <v-icon large>mdi-cash-multiple</v-icon>
                         </div>
                         <div class="col-md-12 ">
                           <div>Montant payer:</div>
                           <div style="font-weight: bold">
                             {{ state }} XOF
                             </div>
                         </div>
                       </div>
                     </v-card>
                   </v-col>
                   <v-col  cols="12" lg="3" md="4" class="mt-0 pt-0">
                     <v-card style="padding: 15px">
                       <div class="row"  style="background: #fff">
                         <div class="col-md-12 pt-2 pb-0">
                           <v-icon large>mdi-list-status</v-icon>
                         </div>
                         <div class="col-md-12 ">
                           <div>Statut de la transaction:</div>
                           <div style="font-weight: bold">
                             <span class="badge badge-danger" v-if="transaction_data._archive"> Archiver</span>
                             <span class="badge badge-success" v-if="!transaction_data._archive && transaction_data._status"> Terminer</span>
                             <span class="badge badge-warning" v-if="!transaction_data._archive && !transaction_data._status"> En cours</span>
                             </div>
                         </div>
                       </div>
                     </v-card>
                   </v-col> 
                 </v-row>
             </div>
               
                   <v-col cols="12" lg="12" class="mt-0 pt-0">
                       <v-data-table
                           :headers="transaction_logs_headers"
                           :items="logs_transactions"
                           :items-per-page="15"
                           class="elevation-1"
                           :loading="!logs_transactions"
                           no-data-text="Aucune transaction trouvée"
                       >
                        <template v-slot:item._status="{item}">
                         <span :class=" item._status ? 'badge badge-success text-uppercase' : 'badge badge-warning text-uppercase'">  
                           {{ item._status ? 'Payé' : 'en attente' }}
                         </span>
                       </template>
                       <!-- <template v-slot:item._created_at="{item}">
                         {{ getDate(item._createdAt) }}
                       </template> -->
                       <template v-slot:item._price="{item}">
                         {{ item._amount }} F CFA
                       </template>
                       <!-- <template v-slot:item._last_notification="{item}">
                         {{ getDate(item._last_notification) }}
                       </template> -->
                       <!-- <template v-slot:item._number_notification="{item}">
                         <span v-for="(data, index) in item._notification_logs" :key="index" class="badge badge-info mr-2">
                           {{ data._created_at ?  getDate(item._created_at) : ''}}
                         </span>
                       </template> -->
                       <template v-slot:item._paid_at="{item}">
                         <span v-if="!item._status" class="badge badge-warning">en attente</span>
                         <span v-else class="badge badge-success"> {{ getDate(item._createdAt) }}</span>
                       </template>
                       </v-data-table>
                   </v-col>
           </v-card-text>
           <v-card-actions>
             <div class="col-12 pt-0 mt-0">
             <button class="ml-2 btn btn-light btn-sm" @click="closeLogsTransaction">Annuler</button>
             </div>
            </v-card-actions>
         </v-card>
       </v-dialog>
</template>

<script>
   import helpers from "../../../mixins/helpers";
export default {
 props: ["transaction_data","openPaiementLogs","logs_transactions"],
 name: "Logs_paiement",
 mixins:[helpers(this)],
 data() {
   return {
     loadingTransactions:false,
     showPaiementDialog: false,
   }
 },
 methods: {
   closeLogsTransaction(){
     this.$parent.closeLogsTransaction();
   },
   sumPaidTransaction(transactions){
     let total=0;
     for(const transact of transactions){
         total+=transact._price;
     }
     return total;
   }
 },
 computed: {
  transaction_logs_headers: function(){
     return [
       {text: 'Statut', value: '_status'},
       {text: 'Transaction_id', value: '_id'},
    //    {text: 'Dernière notification', value: '_last_notification'},
       {text: 'Montant', value: '_price'},
       {text: 'Payé le', value: '_paid_at'},
      //  {text: 'Date de création', value: '_created_at'},
     ]
   }
 },
}
</script>